import { FC, ReactNode, useState } from "react";
import { TopBar } from "./TopBar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { MenuMobile } from "./MenuMobile";
import { SocialButtons } from "./SocialButtons";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import IconHome from "../../iconComponents/IconStart";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useHistory, useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";

export interface HeaderProps {
  rightElement?: ReactNode;
}

export const Header: FC<HeaderProps> = (props) => {
  const customProfile = {
    anonymous: {
      css: {
        bg: "xvia-header-bg-profile-anonymous",
        bgButton: "#fff",
        bgButtonTop: "buttonTop-profile-anonymous",
      },
    },
  };
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(800));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down(1150));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const history = useHistory();
  const location = useLocation();

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      label: "Início",
      icon: <IconHome />,
      path: "/",
    },
    {
      label: "Serviços Disponíveis",
      icon: <AutoAwesomeOutlinedIcon />,
      path: "/app/catalog/carta-de-servicos",
    },
    {
      label: "Órgãos e Secretarias",
      icon: <AccountBalanceOutlinedIcon />,
      path: "/app/catalog/orgaos-e-secretarias",
    },
    {
      label: "Notícias",
      icon: <NewspaperIcon />,
      path: "/app/catalog/noticias",
    },
  ];

  const visibleItemCount = isSmallScreen ? 0 : isMediumScreen ? 4 : 6;
  const visibleItems = menuItems.slice(0, visibleItemCount);
  const hiddenItems = menuItems.slice(visibleItemCount);

  return (
    <>
      <header className="xvia-header-area">
        <div
          className={
            isSmallScreen
              ? `${customProfile["anonymous"]["css"]["bg"]} xvia-header-container`
              : `${customProfile["anonymous"]["css"]["bg"]} xvia-header-spacing xvia-header-container`
          }
          style={{
            position: "relative",
            width: "100%",
            height: 90,
          }}
        >
          {isSmallScreen ? (
            <div
              style={{
                position: "relative",
                width: "100%",
                height: 90,
                padding: 0,
                margin: 0,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  left: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  margin: 0,
                  padding: 0,
                  zIndex: 2,
                }}
              >
                <MenuMobile
                  hiddenItems={hiddenItems}
                  handleMenuOpen={handleMenuOpen}
                  isSmallScreen={true}
                  anchorEl={anchorEl}
                  handleMenuClose={handleMenuClose}
                />
              </div>
              <a
                href="/"
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                }}
              >
                <img
                  src="/assets/img/logo/xvia-white.png"
                  alt="Logo da X-Via"
                  width={110}
                />
              </a>
              {location.pathname !== "/" && (
                <div
                  style={{
                    position: "absolute",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                  }}
                >
                  <IconButton
                    onClick={() => history.goBack()}
                    sx={{
                      color: "#fff",
                      width: 40,
                      height: 40,
                    }}
                  >
                    <ArrowBackIosNewIcon sx={{ fontSize: 32, color: "#fff" }} />
                  </IconButton>
                </div>
              )}
            </div>
          ) : (
            <>
              <a href="/">
                <img
                  src="/assets/img/logo/xvia-white.png"
                  alt="Logo da X-Via"
                  width={173}
                />
              </a>
              {props.rightElement}
            </>
          )}
        </div>
        {!isSmallScreen && (
          <TopBar
            menuItems={menuItems}
            visibleItems={visibleItems}
            hiddenItems={hiddenItems}
            anchorEl={anchorEl}
            handleMenuOpen={handleMenuOpen}
            handleMenuClose={handleMenuClose}
          />
        )}
      </header>
      {isSmallScreen && (
        <div
          style={{
            background: "#001737",
            padding: 8,
            display: "flex",
            justifyContent: "flex-start",
            paddingLeft: 16,
          }}
        >
          <SocialButtons />
        </div>
      )}
    </>
  );
};
